export default {
  heading: 'conceal, sans-serif',
  subheading: 'conceal, sans-serif',
  body: 'conceal, sans-serif',
  body2: 'conceal, sans-serif',
  monospace: 'Menlo, monospace',
  display: 'Cabin Sketch, cursive',
  googleFonts: [
    'Open Sans:100,200,300,400,500,600,700,800,900',
    'Comfortaa',
    'Cinzel:400,500,600,700,800,900',
    'Raleway'
  ],
  customFamilies: ['Amelie', 'Corinthian Light', 'Futura', 'Rollerscript', 'Canandra'],
  customUrls: [
    'https://www.gonation.biz/fonts/amelie/amelie.css',
    'https://www.gonation.biz/fonts/corinthian-light/corinthian-light.css',
    'https://www.gonation.biz/fonts/futura/futura.css',
    'https://www.gonation.biz/fonts/rollerscript/rollerscript.css',
    'https://www.gonation.biz/fonts/canandra/canandra.css'
  ]
}
